module.exports = __webpack_public_path__ + "media/images/payment_methods/kbc-de7808bbb5a384b847adda0469bb01d4.svg";